// extracted by mini-css-extract-plugin
module.exports = {"store":"StoreDrawer_store_YKmdm","storeName":"StoreDrawer_storeName_3ozMS"};